import { render, staticRenderFns } from "./TypeOfBody.vue?vue&type=template&id=c247b054"
import script from "./TypeOfBody.vue?vue&type=script&lang=js"
export * from "./TypeOfBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports